import styled from "styled-components";

export const Text = styled.p`
  align-self: flex-start;
  padding: 10px 0;
  font-size: 14px;
`;
